import api from './apiHelper';
import { useCustomQuery } from 'hooks/reactQuery';

export const useGetPropertiesByHost = (hostId, { fields, startDate, endDate, HBE } = {}) => {
  const getPropertiesByHost = (key, hostId, fields) => {
    return api.get(`bookingEngine/${hostId}/property`, { params: { fields, startDate, endDate, HBE } });
  };

  return useCustomQuery('property', [hostId, fields, startDate, endDate], getPropertiesByHost, { shouldFetch: !!hostId });
};
